import lrTreeSelect from './_src/lrTreeSelect.vue'

lrTreeSelect.install = function(Vue) {
  Vue.component(lrTreeSelect.name, lrTreeSelect)
}

export default lrTreeSelect